<script lang="ts">
    // import SyncTest from '@shared/components/syncTest.vue'
    import { computed, reactive, ref, onMounted, inject } from 'vue'
    import vm /*, { getLocalStorageItem, removeLocalStorageItem, setLocalStorageItem }*/ from '../Journeys.viewmodel'
    // utils
    import { tmp_uuidv4 /*, UngappedJourney*/ } from '../Journeys.viewmodel'
    // import HumanTime from '@shared/utils/HumanTime/HumanTime'
    // components
    // import FluidButton from '@shared/components/FluidButton.vue'
    // import ScrollableContainer from '@shared/components/ScrollableContainer.vue'
    // import AlertNotification from '@shared/components/Alerts/Notification.vue'
    // import JourneyPreview from './JourneyPreview.vue'
    // import SelectMany from '@shared/components/SelectMany/SelectMany.vue'
    // pages
    // import JourneyNew from './JourneyNew.vue'
    // assets
    // import { JourneySVG, ListViewSVG, GridViewSVG } from '@cwd/shared/assets/vector/ui/IconsUI'
    // import { JourneyStatus } from '@journeys/Enums'
    import { cancelFrame, requestFrame, uid } from '@cwd/shared/utils'
    import { api } from '@cwd/lib/main'
    // import { listingsProcessor_reduce } from '@shared/utils/ListingsController'
    // import { vue_ko_sync } from '@cwd/shared/KoSync'
    import BSDropdownButton from '@shared/components/BSDropdownButton.vue'
    import List from '@shared/components/List.vue'
    import JourneyListItem, { type Journey } from '../components/JourneyListItem.vue'

    // const toHumanTime = new HumanTime({ locale: 'sv' })

    interface JourneysTabData {
        list: { [key: string]: unknown | any }
        heading: string
        intro: string
        notification: string
    }

    const component = {
        name: 'Page_JourneyStart',
    }

    export default {
        name: component.name,
    }

    export const journeysOrderOptions = () => {
        return [
            {
                key: 'LastModified',
                display: $Resources.LastModifiedLabel,
            },
            {
                key: 'Title',
                display: $Resources.TitleLabel,
            },
            {
                key: 'Description',
                display: $Resources.DescriptionLabel,
            },
        ]
    }
</script>

<script lang="ts" setup>
    import { type TagsProvide } from '@shared/components/Tags/Tags.access'
    const tags = inject('tags') as TagsProvide

    const cid = uid()
    const { editor, /* activeJourney, */ startMenu, nav, account } = vm

    onMounted(async () => {
        switchTab(vm.router.currentRoute.value.path.replace('/', ''))

        editor.events.reset()
        nav.x = 0
        nav.y = 0
        nav.z = 0
    })

    const journeysTabs = {
        drafts: { name: 'drafts', display: $Resources.JourneysDraftsTabLabel },
        active: { name: 'active', display: $Resources.JourneysActiveTabLabel },
        ended: { name: 'ended', display: $Resources.JourneysEndedTabLabel },
        templates: { name: 'templates', display: $Resources.JourneysTemplatesTabLabel },
    }

    const currentTab = ref('drafts'),
        tabData: JourneysTabData = reactive({
            list: {},
            heading: $Resources.JourneysDraftsHeading,
            intro: $Resources.JourneysDraftsIntroduction,
            notification: $Resources.JourneysNoDraftsLabel,
        }),
        filteredList = computed(() => {
            let res = Object.values(tabData.list)
            return res as Journey[]
        })

    const setTabData = (data: any[]) => {
        data.forEach((j: any) => {
            j.data = JSON.parse(j.GraphicalData)
            tabData.list[j.JourneyId] = j
        })
    }

    // let entries: any
    // let promises: any
    let newJourneyWindow = ref(false)

    const fetchListings = async (status: string) => {
        tabData.list = {}

        let listing = await account.listings.get(`/journeys/${status}`)

        vm.router.push('/' + status)
        setTabData(listing)
    }

    const switchTab = (tab: string) => {
        currentTab.value = tab
        newJourneyWindow.value = false
        clearSelection()

        switch (tab) {
            case 'drafts':
                fetchListings(tab)

                tabData.heading = $Resources.JourneysDraftsHeading
                tabData.intro = $Resources.JourneysDraftsIntroduction
                tabData.notification = $Resources.JourneysNoDraftsLabel
                break
            case 'active':
                fetchListings(tab)

                tabData.heading = $Resources.JourneysActiveHeading
                tabData.intro = $Resources.JourneysActiveIntroduction
                tabData.notification = $Resources.JourneysNoActiveLabel
                break
            case 'ended':
                fetchListings(tab)

                tabData.heading = $Resources.JourneysEndedHeading
                tabData.intro = $Resources.JourneysEndedIntroduction
                tabData.notification = $Resources.JourneysNoEndedLabel
                break
            case 'templates':
                fetchListings(tab)

                tabData.heading = $Resources.JourneysTemplatesHeading
                tabData.intro = $Resources.JourneysTemplatesIntroduction
                tabData.notification = $Resources.JourneysNoTemplatesLabel
                break
        }
    }

    let observerFrame = 0

    const handleResizeChanges = (val: any) => {
        val.forEach((v: any) => {
            cancelFrame(observerFrame)
            observerFrame = requestFrame(() => {
                let el = v.target
                let obj = resizeObserver[el.dataset.key],
                    { name, value } = obj

                let res = v.contentRect[name] / value
                obj.ref.value = res
            })
        })
    }

    const resizeObserver: any = {
        observer: {},
        callback: handleResizeChanges,
    }

    const deleteSelectedItems = () => {
        let journeys = startMenu.selected.map((id) => {
            return { JourneyId: id }
        })

        api.delete(`/journeys`, journeys).then(() => {
            for (let { JourneyId } of journeys) {
                delete tabData.list[JourneyId!]
            }

            clearSelection()
        })
    }

    const clearSelection = () => {
        startMenu.selected = []
    }

    const cleanJourney = () => {
        vm.router.push('/' + tmp_uuidv4() + '?clean=true')
    }

    const openTemplates = () => {
        vm.router.push('/new')
    }

    const openJourney = (journey: any) => {
        journey.data.JourneyId = journey.JourneyId
        Object.assign(vm.activeJourney, journey.data)

        vm.router.push('/' + journey.data.JourneyId)
    }
</script>

<template>
    <List
        itemId="JourneyId"
        :title="$Resources.JourneysHeader"
        :description="tabData.intro"
        :items="filteredList"
        :loading="editor.state.busy"
        :filterKeys="['Title', 'Description']"
        :orderOptions="journeysOrderOptions()"
        :checkedItems="startMenu.selected"
        displayAs="cards"
        :displayOptions="['default', 'cards']"
        :tabs="journeysTabs"
        :currentTab="currentTab"
        :disableCheckboxes="currentTab === 'active'"
        :tags="tags"
        @update:tab="(newVal) => switchTab(newVal)"
        @update:checkedItems="(newVal) => (startMenu.selected = newVal as string[])"
        @clearSelected="clearSelection"
        @deleteSelected="deleteSelectedItems">
        <template #toolbar>
            <BSDropdownButton menuClass="dropdown-menu-right" v-show="startMenu.selected.length === 0">
                <template #toggle>
                    <span class="glyphicon glyphicon-plus m-xxs-r"></span>
                    {{ $Resources.NewJourneyBtn }}
                </template>
                <template #content>
                    <li role="presentation" class="dropdown-header">{{ $Resources.NewJourneyBtn }}:</li>
                    <li>
                        <a href="javascript:void(0)" :class="editor.state.busy && 'pe-none'" @click="cleanJourney">
                            {{ $Resources.JourneysNewDraftBtnLabel }}
                        </a>
                    </li>
                    <li>
                        <a href="javascript:void(0)" :class="editor.state.busy && 'pe-none'" @click="openTemplates">
                            {{ $Resources.JourneysNewDraftFromTemplateBtnLabel }}
                        </a>
                    </li>
                </template>
            </BSDropdownButton>
        </template>
        <template #item="{ item, index }">
            <JourneyListItem :currentTab="currentTab" :journey="item" :index="index" :tags="tags" @journeyClicked="openJourney(item)"></JourneyListItem>
        </template>
    </List>
</template>

<style lang="less"></style>
